import { AssignedRegion } from 'context/UserContext/types';
import { MasterRegionBasicInfo } from './types';

export const getRegionDisplayName = (region?: MasterRegionBasicInfo | AssignedRegion) => {
    if (!region) return;
    return region.displayName || region.name;
};

export const encodeRegionNameURI = (regionName: string) => {
    return encodeURIComponent(regionName.replaceAll(' ', '_'));
};

export const decodeRegionNameURI = (regionName: string) => {
    return decodeURIComponent(regionName).replaceAll('_', ' ');
};
